module.exports = "/images/vendor/desiigner-svg/svg/logoipsum/logoipsum-4.svg?65a2fe77bfe4c13e6c2bfe1b9b51ac3d";